import { render, staticRenderFns } from "./TheExtraSNS.vue?vue&type=template&id=58a14d7e&"
import script from "./TheExtraSNS.vue?vue&type=script&lang=js&"
export * from "./TheExtraSNS.vue?vue&type=script&lang=js&"
import style0 from "./TheExtraSNS.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports